<template>
  <div class="main">
    <MyHeader index="4"></MyHeader>
    <div class="titleIfo">
      <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
        <h2>资源</h2>
        <h3>Resources</h3>
      </div>
      <div class="container" v-if=" this.$i18n.locale == 'en_US'">
        <h2>Resources</h2>
        <h3>资源</h3>
      </div>
    </div>
    <div class="resourceInfo">
      <div class="container">
        <div class="info">
          <h2 class="title">{{date.name}}</h2>
          <h3 class="publish">
            <b>{{$t('label.author')}}{{date.author}}</b>
            <i>{{$t('label.release')}}{{date.release_time}}</i>
          </h3>
          <!--
          <h4 class="tips">报告简介</h4>-->

          <div v-html="date.content" class="text" style="margin-top:30px;margin-bottom:30px;"></div>

          <h6 v-if="date.attachment !== ''">
            <i>{{$t('label.attachment')}}</i>
            <a :href="date.attachment">
              <b>{{date.attachment_name}}</b>
            </a>
          </h6>
        </div>
        <div class="otherList">
          <div class="title fa-Middle">
            <img src="./image/resource.png" alt="resource" />
            <h3>{{$t('label.resource')}}</h3>
          </div>
          <div class="otherInfo">
            <h2 class="infoTitle" v-if="flag">{{$t('label.otherresource')}}</h2>
            <ul class="list">
              <li v-for="(item,index) in datalist" :key="index" @click="toResource(item.id)">
                <h4>{{item.name}}</h4>
                <h5>{{item.author}} {{item.issue}}</h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<script>
import MyHeader from "./common/MyHeader";
import MyFooter from "./common/MyFooter";
import filter from "../filter.js";
import {
  createArticle,
  getArticleList,
  getArticleDetails,
  deleteArticle,
  putArticle,
  getRecommend
} from "@/services/article";

export default {
  name: "ResourcePage",
  components: { MyHeader, MyFooter },
  data() {
    return {
      id: this.$route.params.id,
      date: {},
      moreList: [],
      category: {
        recommend_id: this.$route.params.id,
        category_id: [76, 77, 78],
        page_size: 2
      },
      flag: true,
      datalist: [],
      flag1: false
    };
  },
  mounted() {
    this.getDetails(this.id);
    this.getList();
  },
  watch: {
    $route(to, from) {
      console.log(to.params.id);

      this.category.recommend_id = to.params.id;
      this.getDetails(to.params.id);
      this.getList();
    }
  },
  methods: {
    getDetails(id) {
      getArticleDetails(id)
        .then(res => {
          let data = res;
          data.release_time = filter.dateFormat(
            data.release_time,
            "yyyy-mm-dd"
          );
          this.date = data;
          console.log(this.date);
          if (this.date) {
            this.flag1 = true;
          }
        })
        .catch(err => {});
    },
    getList() {
      getRecommend(this.category)
        .then(res => {
          let list = res.items;
          for (var i in list) {
            let item = list[i];
            item.issue = filter.dateFormat(item.release_time, "yyyy-mm-dd");
          }
          this.moreList = list;
          this.datalist = this.moreList.reverse();
          console.log(this.datalist, 11);
          if (this.datalist.length == 0) {
            this.flag = false;
          }
        })
        .catch(err => {});
    },
    toResource(id) {
      this.$router.push("/resource/" + id);
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  .titleIfo {
    width: 100%;
    height: 380px;
    background: url("./image/resources.jpg") no-repeat center center;
    background-size: cover;
    .container {
      h2 {
        padding-top: 180px;
        text-align: center;
        color: #ffffff;
        height: 42px;
        font-size: 32px;
        font-weight: bold;
        line-height: 42px;
      }
      h3 {
        text-align: center;
        height: 29px;
        font-size: 22px;
        line-height: 29px;
        color: #ffffff;
      }
    }
  }
  .resourceInfo {
    .container {
      padding-top: 112px;
      padding-bottom: 48px;
      overflow: hidden;
      .info {
        width: 794px;
        float: left;
        .title {
          font-size: 26px;
          color: #191919;
          line-height: 42px;
          font-weight: bold;
        }
        .publish {
          margin-top: 20px;
          font-size: 12px;
          color: #a0a0a0;
          line-height: 16px;
          overflow: hidden;
          b {
            &:after {
              content: "  ｜  ";
            }
          }
          &:after {
            margin-top: 33px;
            content: "";
            display: block;
            width: 40px;
            height: 3px;
            background-color: #888888;
          }
        }
        .tips {
          margin-top: 40px;
          font-size: 18px;
          color: #191919;
          height: 24px;
          line-height: 24px;
          font-weight: bold;
          margin-bottom: 16px;
        }
        .text {
          text-indent: 2em;
        }
        h6 {
          line-height: 18px;
          height: 18px;
          font-size: 12px;
          overflow: hidden;
          margin-top: 16px;
          i {
            display: block;
            color: #666666;
            float: left;
          }
          a {
            overflow: hidden;
            display: block;
            float: left;
            b {
              float: left;
              color: #0191ff;
              line-height: 18px;
              height: 18px;
              display: inline-block;
            }
            &:before {
              float: left;
              display: inline-block;
              width: 14px;
              height: 18px;
              content: " ";
              background: url("./image/rarzip.png") no-repeat center center;
              margin-right: 8px;
            }
            &:after {
              float: left;
              display: inline-block;
              width: 14px;
              height: 18px;
              content: " ";
              background: url("./image/download.png") no-repeat center center;
              background-size: 100%;
            }
          }
        }
      }
      .otherList {
        width: 270px;
        float: right;
        .title {
          height: 60px;
          background-image: linear-gradient(41deg, #12ad6c 0%, #01a1e5 100%);
          border-radius: 3px;
          img {
            margin-top: 2px;
          }
          h3 {
            margin-left: 10px;
            font-size: 24px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            line-height: 24px;
          }
        }
        .otherInfo {
          margin-top: 40px;
          .infoTitle {
            color: #252525;
            font-size: 18px;
            font-weight: bold;
            height: 20px;
            line-height: 20px;
            padding-left: 10px;
            border-left: 5px #44be86 solid;
          }
          .list {
            margin-top: 25px;
            li {
              margin-bottom: 32px;
              a {
                display: block;
                h4 {
                  font-size: 14px;
                  color: #252525;
                  line-height: 20px;
                  margin-bottom: 10px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                h5 {
                  height: 16px;
                  font-size: 12px;
                  color: rgba(153, 153, 153, 1);
                  line-height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
